var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height fill-width"},[_c('PublicSessionVideo',_vm._b({},'PublicSessionVideo',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }